export default __webpack_public_path__ + "647e64b.png";